import type { FourPillars, PillarPosition } from '../types/pillars';
import type { Relation, RelationOptions, RelationType } from '../types/relations';
import { findHeavenlyCombines } from './heavenly-combine';
import { findHeavenlyClashes } from './heavenly-clash';
import { findEarthlyCombines } from './earthly-combine';
import { findEarthlyClashes } from './earthly-clash';
import { findEarthlyPunishments } from './earthly-punish';
import { findEarthlyDestroys } from './earthly-destroy';
import { findEarthlyHarms } from './earthly-harm';
import { resolveRelationPriority } from './priority';

/** 원국 형충파해 유형 (잠재 마킹 대상) */
const DORMANT_TYPES: ReadonlySet<RelationType> = new Set([
  '육충', '삼형', '상형', '자묘형', '자형', '파', '해',
]);

export function analyzeRelations(
  fourPillars: FourPillars,
  noHour?: boolean,
  options?: RelationOptions,
): Relation[] {
  const positions: readonly PillarPosition[] = noHour ? ['year', 'month', 'day'] : ['year', 'month', 'day', 'hour'];

  const stems = positions.map(pos => ({
    stem: fourPillars[pos].stem,
    position: pos,
  }));

  const branches = positions.map(pos => ({
    branch: fourPillars[pos].branch,
    position: pos,
  }));

  const monthBranch = fourPillars.month.branch;

  const result = [
    ...findHeavenlyCombines(stems, monthBranch, options),
    ...findHeavenlyClashes(stems),
    ...findEarthlyCombines(branches, monthBranch, options),
    ...findEarthlyClashes(branches),
    ...findEarthlyPunishments(branches),
    ...findEarthlyDestroys(branches),
    ...findEarthlyHarms(branches),
  ];

  // 잠재/발동 마킹: 원국 형충파해는 dormant=true
  if (options?.markDormant) {
    for (const r of result) {
      if (DORMANT_TYPES.has(r.type)) {
        r.dormant = true;
      }
    }
  }

  // 우선순위 해소
  if (options?.resolvePriority) {
    resolveRelationPriority(result, fourPillars, noHour);
  }

  return result;
}

export {
  findHeavenlyCombines,
  findHeavenlyClashes,
  findEarthlyCombines,
  findEarthlyClashes,
  findEarthlyPunishments,
  findEarthlyDestroys,
  findEarthlyHarms,
};

export { analyzeFortuneRelations } from './fortune-relations';
